<template>
  <div id="tabArrivalInformation">
    <div style="width: fit-content">
      <tab-arrival-information-UICustom-layout :element-blocks="elementBlocks" :disabled="readonly">
        <!-- 预计到港时间 -->
        <el-form-item v-if="elementDict.estimatedArrivalTime.visible" slot="estimatedArrivalTime">
          <line-label slot="label" :class="elementDict.estimatedArrivalTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedArrivalTime.label" />
          <el-date-picker
            v-model="form.estimatedArrivalTime"
            no="1"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 实际到港时间 -->
        <el-form-item v-if="elementDict.actualArrivalTime.visible" slot="actualArrivalTime">
          <line-label slot="label" :class="elementDict.actualArrivalTime.isRequire ? 'blue' : ''" :label="elementDict.actualArrivalTime.label" />
          <el-date-picker
            v-model="form.actualArrivalTime"
            no="2"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 预计卸船时间 -->
        <el-form-item v-if="elementDict.estimatedPortDischargeTime.visible" slot="estimatedPortDischargeTime">
          <line-label slot="label" :class="elementDict.estimatedPortDischargeTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedPortDischargeTime.label" />
          <el-date-picker
            v-model="form.estimatedPortDischargeTime"
            no="3"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 实际卸船时间 -->
        <el-form-item v-if="elementDict.portDischargeTime.visible" slot="portDischargeTime">
          <line-label slot="label" :class="elementDict.portDischargeTime.isRequire ? 'blue' : ''" :label="elementDict.portDischargeTime.label" />
          <el-date-picker
            v-model="form.portDischargeTime"
            no="4"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 预计铁路运输时间 -->
        <el-form-item v-if="elementDict.estimatedRailwayDepartureTime.visible" slot="estimatedRailwayDepartureTime">
          <line-label slot="label" :class="elementDict.estimatedRailwayDepartureTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedRailwayDepartureTime.label" />
          <el-date-picker
            v-model="form.estimatedRailwayDepartureTime"
            no="estimatedRailwayDepartureTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 实际铁路运输时间 -->
        <el-form-item v-if="elementDict.railwayDepartureTime.visible" slot="railwayDepartureTime">
          <line-label slot="label" :class="elementDict.railwayDepartureTime.isRequire ? 'blue' : ''" :label="elementDict.railwayDepartureTime.label" />
          <el-date-picker
            v-model="form.railwayDepartureTime"
            no="5"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 预计铁路卸货时间 -->
        <el-form-item v-if="elementDict.estimatedRailwayDischargeTime.visible" slot="estimatedRailwayDischargeTime">
          <line-label slot="label" :class="elementDict.estimatedRailwayDischargeTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedRailwayDischargeTime.label" />
          <el-date-picker
            v-model="form.estimatedRailwayDischargeTime"
            no="6"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 实际铁路卸货时间 -->
        <el-form-item v-if="elementDict.railwayDischargeTime.visible" slot="railwayDischargeTime">
          <line-label slot="label" :class="elementDict.railwayDischargeTime.isRequire ? 'blue' : ''" :label="elementDict.railwayDischargeTime.label" />
          <el-date-picker
            v-model="form.railwayDischargeTime"
            no="7"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 预计抵达交货地时间 -->
        <el-form-item v-if="elementDict.estimatedArrivalPlaceOfDelivery.visible" slot="estimatedArrivalPlaceOfDelivery">
          <line-label slot="label" :class="elementDict.estimatedArrivalPlaceOfDelivery.isRequire ? 'blue' : ''" :label="elementDict.estimatedArrivalPlaceOfDelivery.label" />
          <el-date-picker
            v-model="form.estimatedArrivalPlaceOfDelivery"
            no="8"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 实际抵达交货地时间 -->
        <el-form-item v-if="elementDict.actualArrivalPlaceOfDelivery.visible" slot="actualArrivalPlaceOfDelivery">
          <line-label slot="label" :class="elementDict.actualArrivalPlaceOfDelivery.isRequire ? 'blue' : ''" :label="elementDict.actualArrivalPlaceOfDelivery.label" />
          <el-date-picker
            v-model="form.actualArrivalPlaceOfDelivery"
            no="9"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 预计放关时间 -->
        <el-form-item v-if="elementDict.estimatedCustomsReleaseTime.visible" slot="estimatedCustomsReleaseTime">
          <line-label slot="label" :class="elementDict.estimatedCustomsReleaseTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedCustomsReleaseTime.label" />
          <el-date-picker
            v-model="form.estimatedCustomsReleaseTime"
            no="10"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 实际放关时间 -->
        <el-form-item v-if="elementDict.destPortCustomsClearanceTime.visible" slot="destPortCustomsClearanceTime">
          <line-label slot="label" :class="elementDict.destPortCustomsClearanceTime.isRequire ? 'blue' : ''" :label="elementDict.destPortCustomsClearanceTime.label" />
          <el-date-picker
            v-model="form.destPortCustomsClearanceTime"
            no="11"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 预计提重时间 -->
        <el-form-item v-if="elementDict.estimatedPickUpTime.visible" slot="estimatedPickUpTime" :title="elementDict.estimatedPickUpTime.label">
          <line-label slot="label" :class="elementDict.estimatedPickUpTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedPickUpTime.label" />
          <el-date-picker
            v-model="form.estimatedPickUpTime"
            no="12"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 实际提重时间 -->
        <el-form-item v-if="elementDict.actualPickUpTime.visible" slot="actualPickUpTime" :title="elementDict.actualPickUpTime.label">
          <line-label slot="label" :class="elementDict.actualPickUpTime.isRequire ? 'blue' : ''" :label="elementDict.actualPickUpTime.label" />
          <el-date-picker
            v-model="form.actualPickUpTime"
            no="13"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.estimatedDeliveryToWarehouseTime.visible" slot="estimatedDeliveryToWarehouseTime" :title="elementDict.estimatedDeliveryToWarehouseTime.label">
          <line-label slot="label" :class="elementDict.estimatedDeliveryToWarehouseTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedDeliveryToWarehouseTime.label" />
          <el-date-picker
            v-model="form.estimatedDeliveryToWarehouseTime"
            no="14"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.deliveryTime.visible" slot="deliveryTime" :title="elementDict.deliveryTime.label">
          <line-label slot="label" :class="elementDict.deliveryTime.isRequire ? 'blue' : ''" :label="elementDict.deliveryTime.label" />
          <el-date-picker
            v-model="form.deliveryTime"
            no="15"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destPortDeliveryTime.visible" slot="destPortDeliveryTime" :title="elementDict.destPortDeliveryTime.label">
          <line-label slot="label" :class="elementDict.destPortDeliveryTime.isRequire ? 'blue' : ''" :label="elementDict.destPortDeliveryTime.label" />
          <el-date-picker
            v-model="form.destPortDeliveryTime"
            no="16"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.deliveryCompletionDate.visible" slot="deliveryCompletionDate" :title="elementDict.deliveryCompletionDate.label">
          <line-label slot="label" :class="elementDict.deliveryCompletionDate.isRequire ? 'blue' : ''" :label="elementDict.deliveryCompletionDate.label" />
          <el-date-picker
            v-model="form.deliveryCompletionDate"
            no="17"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 预计还空时间 -->
        <el-form-item v-if="elementDict.estimatedReturnTime.visible" slot="estimatedReturnTime">
          <line-label slot="label" :class="elementDict.estimatedReturnTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedReturnTime.label" />
          <el-date-picker
            v-model="form.estimatedReturnTime"
            no="20"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 实际还空时间 -->
        <el-form-item v-if="elementDict.destPortReturnTime.visible" slot="destPortReturnTime">
          <line-label slot="label" :class="elementDict.destPortReturnTime.isRequire ? 'blue' : ''" :label="elementDict.destPortReturnTime.label" />
          <el-date-picker
            v-model="form.destPortReturnTime"
            no="21"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
      </tab-arrival-information-UICustom-layout>
    </div>
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabArrivalInformationUICustomLayout from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabArrivalInformationUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabArrivalInformation from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabArrivalInformation'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'TabArrivalInformationUICustom',
  components: { tabArrivalInformationUICustomLayout },
  extends: tabArrivalInformation,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null // 用于调用父级的方法
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SI_BOOKING_ARRIVAL_INFO, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    validateForm() {
      const form = this.form
      for (const key in this.fieldDict) {
        const field = this.fieldDict[key]
        if (field.visible && field.isRequire) {
          if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabArrivalInformation')
          }
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return this.superFunction()
    }
  }
}
</script>
